var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-titled"},[_c('div',{staticClass:"div-titled__title"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"div-titled__border"}),_c('div',{staticClass:"div-titled__main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }